<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      unit="加工单元"
      edit-title
      id-key="AbstractId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
      :before-save="onBeforeSave"
      @closed="over"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="序号">
              <el-input
                type="number"
                v-int
                v-model="data.Sn"
                style="width: 100px"
              ></el-input>
              <span class="t-tips">*值越小排得越前</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="data.Status" class="detail-span">
                <el-radio :label="1">在用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="加工阶段">
              <el-select v-model="data.Stage" clearable @change="changeStage">
                <el-option
                  v-for="item in machiningStageList"
                  :key="item.MachiningStageId"
                  :value="item.MachiningStageId"
                  :label="item.Name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加工单元类型" label-width="100px">
              <div v-if="!data.Stage">请先选择加工阶段</div>
              <el-select
                v-else
                v-model="data.ProcessUnitType"
                clearable
                @visible-change="onProcessUnitType($event)"
              >
                <el-option
                  v-for="item in TeProcessUnitTypeList"
                  :key="item.ProcessUnitTypeId"
                  :value="item.ProcessUnitTypeId"
                  :label="item.ProcessUnitTypeName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单元编号">
              <el-input v-model="data.ProcessUnitNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单元名称">
              <el-input v-model="data.ProcessUnitName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <div
        style="display: flex; justify-content: space-between; margin: 10px 0"
      >
        <div>设备列表</div>
        <div><el-button type="primary" @click="add">添加</el-button></div>
      </div>
      <el-table ref="multipleTable" :data="facList" border>
        <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
        <el-table-column label="编号">
          <template slot-scope="{ row }">{{ row.EquipmentNo }}</template>
        </el-table-column>
        <el-table-column prop="EquipmentName" label="设备名称">
        </el-table-column>
        <el-table-column prop="EquipmentStatusName" label="状态">
        </el-table-column>
        <el-table-column label="日产能(设备标准产出量)" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.Workload }}</template>
        </el-table-column>
        <el-table-column label="单位">
          <template slot-scope="{ row }">{{ row.UnitName }}</template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作"
          show-overflow-tooltip
          width="60"
        >
          <template slot-scope="{ row,$index }">
            <el-button
              @click.native="del(row, $index)"
              type="text"
              style="color: red"
              >移除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-button type="primary" @click="toSave">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template>
    </common-dialog>

    <manage-select
      ref="manageSelect"
      in-dialog
      selectable
      multiple
      @select-multiple="setManage"
    ></manage-select>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import invoiceSelect from "@/components/basedata/basedoc/billtype/select";
import manageSelect from "@/components/facility/manage/listDialog.vue";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    invoiceSelect,
    manageSelect,
  },
  data() {
    return {
      data: {
        ProcessUnitId: 0,
        Sn: null,
        Status: 1,
        Stage: null,
        ProcessUnitTypeId: null,
        ProcessUnitNo: null,
        ProcessUnitType: null,
        ProcessUnitName: null,
        DetailDtos: [],
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/production/teProcessUnit").default,
      machiningStageApi: require("@/api/ba/machiningStage").default,
      teProcessUnitTypeApi: require("@/api/production/teProcessUnitType").default,
      code_api: require("@/api/sy/serialCode").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        TransportNo: [{ required: true, message: "请输入编号" }],
        Abstract: [{ required: true, message: "请输入描述" }],
        SerialNumber: [{ required: true, message: "请输入序号" }],
      },
      facList: [],
      machiningStageList: [],
      TeProcessUnitTypeList: [],
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened(data) {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });

      this.machiningStageApi.list({ Status: 1 }).then((res) => {
        this.machiningStageList = res.Data;
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened(data) {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
      this.code_api.previewNo("加工单元").then((res) => {
        if (res.Code == 0) {
          this.data.ProcessUnitNo = res.Data.PreviewNo;
          console.log(
            "🚀 ~ this.code_api.previewNo ~ this.data.EquipmentNo:",
            this.data.EquipmentNo
          );
        } else {
          this.$message.warning("获取加工单元编号失败");
        }
      });
    },
    onEditOpened(data) {
      this.data.ProcessUnitId = data.ProcessUnitId;
      this.api.info(data.ProcessUnitId).then((res) => {
        this.facList = res.Data.DetailDtos;
        this.teProcessUnitTypeApi
          .list({ Stage: res.Data.Stage })
          .then((res) => {
            this.TeProcessUnitTypeList = res.Data;
          });
      });
    },
    onClosed() {
      this.showList = [];
    },
    onProcessUnitType(e) {
      if (e) {
        this.teProcessUnitTypeApi
          .list({ Stage: this.data.Stage })
          .then((res) => {
            this.TeProcessUnitTypeList = res.Data;
          });
      }
    },
    changeStage() {
      this.data.ProcessUnitType = null;
    },
    add() {
      this.$refs.manageSelect.open().then((that) => that.getData());
    },
    setManage(data) {
      // console.log("data", data);
      const Ids = this.facList.map((i) => i.EquipmentId) ?? [];
      const addList = data.reduce((acc, item) => {
        if (!Ids.includes(item.EquipmentId)) acc.push({ T: 0, ...item });
        return acc;
      }, []);
      this.facList = [...this.facList, ...addList];
    },
    del(data, index) {
      this.facList.splice(index, 1);
    },
    toSave() {
      if (this.data.DetailDtos.length == 0) {
        this.data.DetailDtos = this.facList.map((item) => ((item.T = 0), item));
      } else {
        let delIds = this.facList.map((item) => item.ProcessUnitDetailId);
        let delList = this.data.DetailDtos.reduce((arr, item) => {
          if (!delIds.includes(item.ProcessUnitDetailId))
            arr.push({ ...item, T: 2 });
          return arr;
        }, []);

        let addIds = this.data.DetailDtos.map(
          (item) => item.ProcessUnitDetailId
        );
        let addList = [];
        addList = this.facList.reduce((arr, item) => {
          if (!addIds.includes(item.ProcessUnitDetailId))
            arr.push({ ...item, T: 0 });
          return arr;
        }, []);

        let updateList = this.facList.filter((item) => item.T === 1);
        this.data.DetailDtos = [...addList, ...delList, ...updateList];
      }

      this.api.verify(this.data).then((res) => {
        if (res.Code == 0) {
          this.api.save(this.data).then((res) => {
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        } else {
          this.$confirm(res.Msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.api.save(this.data).then((res) => {
                if (res.Code == 0) {
                  this.$message.success(res.Msg);
                  this.close(true);
                } else {
                  this.$message.error(res.Msg);
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    onBeforeSave() {},
    delRow() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let delList = this.multipleSelection.map((item) => item.DistrictId);
          let data = this.areaList.filter(
            (item) => !delList.includes(item.DistrictId)
          );
          this.areaList = JSON.parse(JSON.stringify(data));
        })
        .catch(() => {});
    },
    over() {
      this.facList = [];
    },
  },
};
</script>
